module.exports = __webpack_public_path__ + "media/metal_sheet_3.96047ab5.mp3";